export default {
    isRecaptchaEnabled: () => {
        if(typeof window.initInfo.is_recaptcha_enabled == 'boolean')
            return window.initInfo.is_recaptcha_enabled;
        else return true;
    }
}



// WEBPACK FOOTER //
// ./src/utils/recaptcha.js